// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-disabled[data-v-682046ca]{opacity:.5}.subitem-disabled[data-v-682046ca]{opacity:.5}`, "",{"version":3,"sources":["webpack://./src/components/AppNavigationContactsItem.vue"],"names":[],"mappings":"AACA,gCACC,UAAA,CAGD,mCACC,UAAA","sourcesContent":["\n.item-disabled {\n\topacity: 0.5;\n}\n\n.subitem-disabled {\n\topacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
